<template>
   <div>
       <div class="tabs__header">
           <a href="#" class="tab__title"
              v-for="(tab, index) in tabs"
              :key="tab.title"
              :class="{tab__selected: index===selectedIndex}"
              @click.prevent="selectTab(index)">{{ tab.title}}</a>
       </div>
       <div class="tab__body">
           <slot></slot>
       </div>
   </div>
</template>

<script>
    export default {
        name: "Tabs",

        data() {
            return {
                selectedIndex: 0,
                tabs: [],
            }
        },

        created() {
            this.tabs = this.$children;
        },

        mounted() {
            this.selectTab(0);
        },

        methods: {
            selectTab(i) {
                this.selectedIndex = i;

                this.tabs.forEach((tab, index) => {
                    tab.isActive = (index === i);
                })
            }
        }
    }
</script>

<style scoped>
    .tabs__header {
        display: flex;
        justify-content: flex-start;
    }
    .tab__title {
        display: inline-block;
        padding: .5rem 2rem;
        background-color: #607181;
        color: #E4E5E6;
        border-top-left-radius: .5rem;
        border-top-right-radius: .5rem;
    }
    .tab__body {
        background-color: #E4E5E6;
        padding: 2rem;
        border-bottom-right-radius: .5rem;
        border-bottom-left-radius: .5rem;
        border-top-right-radius: .5rem;
    }
    .tab__selected {
        background-color: #2F58A7;
        color: #E4E5E6;
    }
</style>